import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class IncalculationParent extends List {
  constructor(obj) {
    super(Incalculation, obj)
  }
}

export class Incalculation {
  constructor(obj) {
    this.id = obj?.id || null
    this.inculcationLevel = obj?.inculcationLevel || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.inculcationPlace = obj?.inculcationPlace || null
    this.inculcationDate = obj?.inculcationDate || null
    this.inculcationAct = obj?.inculcationAct || null
    this.inculcationArea = obj?.inculcationArea || null
    this.remark = obj?.remark || null
    this.fullBibliographic = obj?.fullBibliographic || null
    this.link = obj?.link || null
  }

  getForAPI() {
    return {
      id: this.id,
      inculcationLevel: this.inculcationLevel,
      commonWork: this.commonWork.getForAPI(),
      inculcationPlace: this.inculcationPlace,
      inculcationDate: this.inculcationDate,
      inculcationAct: this.inculcationAct,
      inculcationArea: this.inculcationArea,
      remark: this.remark,
      fullBibliographic: this.fullBibliographic,
      link: this.link
    }
  }
}
